var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/addedToCartIcon.2d48e73f.png","uri@2x": __webpack_public_path__ + "static/media/addedToCartIcon.ed332f78.png","uri@3x": __webpack_public_path__ + "static/media/addedToCartIcon.acb68213.png",
    width: 24,
    height: 24
});